import { createSlot } from "lib/@components/slot/create-slot"

export const AdditionalFieldInput = createSlot("AdditionalFieldInput")
